/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { useActivation } from '@context/MobileOne';
import {
  ButtonPrimary,
  ButtonRadio,
  CardInfoboxChip,
  Notification,
  CardSupport,
  ScrollToTop,
  ButtonCancelActivation
} from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import {
  appAlert,
  appButtonType,
  appCardStyle,
  appIconsPath,
  appInfoCardSize,
  appRadioSize
} from '@utils/globalConstant';
import './Step3.scss';
import { useStaticContent } from '@context/StaticContent';

export function MNPInitialization() {
  // Contexts
  const {
    setShowActivationHeader,
    setWithMNP,
    setStep3SubStep,
    setShowActivationCancelModal,
    phoneNumberActivationForm,
    setPhoneNumberActivationForm
  } = useActivation();
  const { staticContentData } = useStaticContent();

  // Const
  const headerContent = tA11y('ek_reg_mnp_hdl1');
  const cardHeaderContent = tA11y('ek_reg_mnp_rec_hdl1');
  const cardTextContent = tA11y('ek_reg_mnp_rec_txt1');
  const radio1Content = tA11y('ek_reg_mnp_radiobtn1');
  const radio2Content = tA11y('ek_reg_mnp_radiobtn2');
  const radioErrorContent = tA11y('ek_reg_mnp_err');
  const bttonContent = tA11y('ek_reg_mnp_btn1');

  // state
  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  const [image, setImage] = useState('');

  // Functions
  const handleRadio = (val) => {
    setValue(val);
    setError(null);
  };

  const handleButtonClick = () => {
    if (!value) {
      setError(true);
      document.getElementById('withMNP').focus();
      return;
    }
    if (value !== 'withMNP') {
      setWithMNP(false);
      setPhoneNumberActivationForm({ ...phoneNumberActivationForm, mnp: false });
      setStep3SubStep(2);
      setShowActivationHeader(false);
    } else {
      setShowActivationHeader(true);
      setPhoneNumberActivationForm({ ...phoneNumberActivationForm, mnp: true });
      setStep3SubStep(1);
      setWithMNP(true);
    }
  };

  // Hooks
  useEffect(() => {
    if (phoneNumberActivationForm.mnp !== null) {
      setValue(phoneNumberActivationForm.mnp ? 'withMNP' : 'withoutMNP');
    }
  }, []);

  useEffect(() => {
    if (staticContentData && staticContentData.media_image) {
      const findImage = staticContentData.media_image.find(
        (item) => item.image_ref === 'ek_reg_mnp_content-1'
      );
      if (findImage) setImage(findImage);
    }
  }, [staticContentData]);

  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
          <AppPageContentWrapper>
            <div className="mnp-initialization w-100">
              {headerContent?.content !== '' && headerContent?.content !== undefined && (
                <>
                  {headerContent?.isHtml ? (
                    <h2
                      className="ek-h2 text-primary m-0"
                      dangerouslySetInnerHTML={{ __html: sanitizeRichText(headerContent?.content) }}
                    />
                  ) : (
                    <h2 className="ek-h2 text-primary m-0">{headerContent?.content}</h2>
                  )}
                </>
              )}
              <div className="my-40">
                <div className="col-12">
                  <CardInfoboxChip
                    className="mt-40"
                    cardStyle={appCardStyle.SECONDARY}
                    cardSize={appInfoCardSize.DEFAULT}
                    chipIcon={appIconsPath.STAR}
                    chipLabel={cardHeaderContent?.content}
                    text={cardTextContent?.content}
                  />
                </div>
              </div>
              <div className="input-container w-100">
                <ButtonRadio
                  name="mnp"
                  id="withMNP"
                  isChecked={value === 'withMNP'}
                  label={radio1Content?.content}
                  radioSize={appRadioSize.LARGE}
                  invalid={error}
                  onClick={() => handleRadio('withMNP')}
                  radioClass="mb-40"
                  aria-describedby="mnp-error"
                />
                <ButtonRadio
                  name="mnp"
                  id="withoutMNP"
                  isChecked={value === 'withoutMNP'}
                  label={radio2Content?.content}
                  radioSize={appRadioSize.LARGE}
                  invalid={error}
                  onClick={() => handleRadio('withoutMNP')}
                  aria-describedby="mnp-error"
                />
                {error ? (
                  <div className="pt-20 ps-32" id='mnp-error'>
                    <Notification type={appAlert.ERROR} message={radioErrorContent?.content} />
                  </div>
                ) : null}
                <div className="w-100 d-flex justify-content-center mt-40">
                  <div style={{ height: '195px', width: '329px' }}>
                    <img
                      className="img-fluid object-fit-cover"
                      src={image.media_url_display}
                      alt={image.alt_text}
                    />
                  </div>
                </div>
                <div className="w-100 d-flex justify-content-center">
                  <div className="col-xxl-5 col-lg-5 col-10 px-0 my-40">
                    <ButtonPrimary
                      buttonType={appButtonType.PRIMARY}
                      iconRight={appIconsPath.ARROW_RIGHT}
                      onClick={handleButtonClick}
                      buttonContent={bttonContent}
                    />
                  </div>
                </div>
                <CardSupport />
                <div className="d-flex justify-content-center mt-32">
                  <ButtonCancelActivation />
                </div>
              </div>
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default MNPInitialization;
